export default "__VITE_ASSET__6bDFIDYt__"